import { render } from "./TheTermsModal.vue?vue&type=template&id=164f6654&scoped=true"
import script from "./TheTermsModal.vue?vue&type=script&lang=js"
export * from "./TheTermsModal.vue?vue&type=script&lang=js"

import "./TheTermsModal.vue?vue&type=style&index=0&id=164f6654&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164f6654"]])

export default __exports__